<form class="form" [formGroup]="formGroup" (ngSubmit)="onSubmit($event)">
  <div class="fields-container">
    <div class="field-set">
      <label label>Designação*</label>

      <app-input-box
        formControlName="description"
        [showErrorEnabled]="false"
        [appBlockModalDrag]="!(isMobileModeObservable | async)"
      ></app-input-box>
    </div>

    <div class="field-set">
      <label label>Sistema de coordenadas*</label>

      <app-select-box
        formControlName="format"
        [items]="formatList"
        displayExpr="text"
        valueExpr="value"
        [showErrorEnabled]="false"
        [appBlockModalDrag]="!(isMobileModeObservable | async)"
      ></app-select-box>
    </div>

    <div class="field-set align-items-center">
      <label label>Ficheiro (.zip)*</label>

      <input
        #inputFileEl
        formControlName="file"
        type="file"
        accept=".zip"
        [hidden]="true"
        (change)="onFileChange($event)"
      />

      <app-button
        styleType="outlined"
        buttonType="primary"
        text="Procurar"
        width="12rem"
        (click)="onBtnSearchFileClick()"
        [appBlockModalDrag]="!(isMobileModeObservable | async)"
      ></app-button>
    </div>
  </div>

  <div class="info" [appBlockModalDrag]="!(isMobileModeObservable | async)">
    O ficheiro '.zip' deverá conter o '.shp', '.dbf' e '.shx' respetivo. Para
    mais informação, descarregar a informação técnica da estrutura da shapefile
    ("link" para o documento - futuro). O upload de um ficheiro de 10MBytes,
    usando uma largura de banda de upload disponível de 2Mbits, será realizado
    em aproximadamente 40 segundos.
  </div>

  <div class="actions">
    <div class="btn-item" [appBlockModalDrag]="!(isMobileModeObservable | async)">
      <app-button
        type="submit"
        styleType="contained"
        buttonType="primary"
        text="Carregar"
        width="12rem"
        [disabled]="isBtnSubmitDisabled"
      ></app-button>
    </div>
  </div>
</form>
